import type { Scene } from 'three'
import { PerspectiveCamera, Vector3 } from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
import type { AnimationPlaybackControls } from 'motion'
import { animate } from 'motion'

const sizes = useSizes()
let scene
let canvas
let instance: PerspectiveCamera
let controls: OrbitControls
let animations: AnimationPlaybackControls[] = []

export default function useCamera(_canvas?: HTMLCanvasElement, _scene?: Scene) {
  if (_scene && _canvas) {
    scene = _scene
    canvas = _canvas

    instance = new PerspectiveCamera(
      46,
      sizes.width.value / sizes.height.value,
      0.01,
      50
    )
    instance.position.set(0, 1, 2.5)
    scene.add(instance)

    controls = new OrbitControls(instance, canvas)
    controls.enableDamping = true
    controls.dampingFactor = 0.2
    controls.maxDistance = 9.8
    controls.minDistance = 0.5
    controls.target.set(0, 0.5, 0)

    const _v = new Vector3()

    controls.addEventListener('change', function () {
      const minPan = new Vector3(-0.5, 0, -0.5)
      const maxPan = new Vector3(0.5, 1, 0.5)

      _v.copy(controls.target)
      controls.target.clamp(minPan, maxPan)
      _v.sub(controls.target)
      instance.position.sub(_v)
    })
    // controls.autoRotate = true
    // controls.saveState()
  }

  function resize() {
    instance.aspect = sizes.width.value / sizes.height.value
    instance.updateProjectionMatrix()
  }

  function update() {
    controls.update()
  }

  function reset() {
    animations.forEach((animation) => animation.stop())
    animations = []

    const initialPosition = instance.position.clone()
    const initialTarget = controls.target.clone()

    animations.push(
      animate(0, 1, {
        onUpdate: (p) => {
          instance.position.x = initialPosition.x + (0 - initialPosition.x) * p
          instance.position.y = initialPosition.y + (1 - initialPosition.y) * p
          instance.position.z =
            initialPosition.z + (2.5 - initialPosition.z) * p
          controls.target.x = initialTarget.x + (0 - initialTarget.x) * p
          controls.target.y = initialTarget.y + (0.5 - initialTarget.y) * p
          controls.target.z = initialTarget.z + (0 - initialTarget.z) * p
        },
        duration: 1,
      })
    )
  }

  function stopReset() {
    animations.forEach((animation) => animation.stop())
    animations = []
  }

  return {
    resize,
    reset,
    stopReset,
    update,
    controls,
    instance,
  }
}
